import React, { useState } from 'react';
import { Map } from './Map';
import { KPICards } from './KPICards';
import { AIInsightPanel } from './AIInsightPanel';
import { FilterBar } from './FilterBar';
import { AssetDrawer } from './AssetDrawer';
import { DownloadIcon, PlusIcon, MapIcon } from 'lucide-react';
import { AddAssetModal } from '../shared/AddAssetModal';
import { SuccessNotification } from '../shared/SuccessNotification';
export const Dashboard: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeStatus, setActiveStatus] = useState('all');
  const [activeClassification, setActiveClassification] = useState('all');
  const [dateRange, setDateRange] = useState({
    start: '',
    end: ''
  });
  const [selectedAsset, setSelectedAsset] = useState<any>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  // Export data function
  const handleExportData = () => {
    setNotification({
      show: true,
      message: 'Data dashboard berhasil diekspor'
    });
  };
  // Add asset function
  const handleAddAsset = () => {
    setIsAddModalOpen(true);
  };
  const handleSubmitAsset = (newAsset: any) => {
    setIsAddModalOpen(false);
    setNotification({
      show: true,
      message: `Aset ${newAsset.name} berhasil ditambahkan`
    });
  };
  // Handle asset selection from map
  const handleAssetSelect = (asset: any) => {
    setSelectedAsset(asset);
    setIsDrawerOpen(true);
  };
  // Close drawer
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };
  return <div className="space-y-6 relative pb-10" data-id="element-413">
      {/* Dashboard Header */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 relative overflow-hidden" data-id="element-414">
        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-primary/5 to-transparent rounded-bl-full -mr-16 -mt-16 pointer-events-none" data-id="element-415"></div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 relative z-10" data-id="element-416">
          <div data-id="element-417">
            <h1 className="text-2xl font-bold text-secondary flex items-center tracking-tight" data-id="element-418">
              <div className="p-2 bg-secondary/5 rounded-lg mr-3 text-secondary" data-id="element-419">
                <MapIcon size={24} data-id="element-420" />
              </div>
              Pusat Kendali Aset Strategis
            </h1>
            <p className="text-sm text-gray-500 mt-1 ml-14" data-id="element-421">
              Monitoring real-time aset teknologi dan infrastruktur vital
              nasional
            </p>
          </div>

          <div className="flex flex-wrap gap-3" data-id="element-422">
            <button className="flex-1 sm:flex-none bg-white border border-gray-300 text-gray-700 px-4 py-2.5 rounded-lg hover:bg-gray-50 hover:border-gray-400 hover:shadow-sm transition-all flex items-center justify-center gap-2 text-sm font-medium" onClick={handleExportData} data-id="element-423">
              <DownloadIcon size={16} data-id="element-424" />
              <span className="hidden sm:inline" data-id="element-425">Ekspor Laporan</span>
              <span className="sm:hidden" data-id="element-426">Ekspor</span>
            </button>
            <button className="flex-1 sm:flex-none bg-secondary text-white px-4 py-2.5 rounded-lg hover:bg-secondary/90 hover:shadow-md hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2 text-sm font-medium shadow-sm" onClick={handleAddAsset} data-id="element-427">
              <PlusIcon size={16} data-id="element-428" />
              <span className="hidden sm:inline" data-id="element-429">Registrasi Aset Baru</span>
              <span className="sm:hidden" data-id="element-430">Tambah</span>
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-4 my-2" data-id="element-431">
        <div className="h-px bg-gray-200 flex-1" data-id="element-432"></div>
        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-433">
          Filter & Analisis
        </span>
        <div className="h-px bg-gray-200 flex-1" data-id="element-434"></div>
      </div>

      <FilterBar activeFilter={activeFilter} setActiveFilter={setActiveFilter} activeCategory={activeCategory} setActiveCategory={setActiveCategory} activeStatus={activeStatus} setActiveStatus={setActiveStatus} activeClassification={activeClassification} setActiveClassification={setActiveClassification} dateRange={dateRange} setDateRange={setDateRange} data-id="element-435" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-436">
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col h-full" data-id="element-437">
          <div className="p-4 border-b border-gray-200 bg-gray-50/50 flex items-center justify-between" data-id="element-438">
            <h2 className="font-bold text-secondary flex items-center text-base" data-id="element-439">
              <MapIcon size={18} className="mr-2 text-primary" data-id="element-440" />
              Peta Sebaran Aset Nasional
            </h2>
            <div className="flex space-x-2" data-id="element-441">
              <div className="text-xs bg-green-100 text-green-800 px-2.5 py-1 rounded-full flex items-center font-medium border border-green-200" data-id="element-442">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5 animate-pulse" data-id="element-443"></span>
                <span className="hidden sm:inline" data-id="element-444">Live Connection</span>
                <span className="sm:hidden" data-id="element-445">Live</span>
              </div>
              <div className="hidden sm:flex text-xs bg-blue-50 text-blue-700 px-2.5 py-1 rounded-full font-medium border border-blue-100" data-id="element-446">
                Secure Layer
              </div>
            </div>
          </div>
          <div className="flex-1 min-h-[400px] sm:min-h-[500px] relative" data-id="element-447">
            <Map activeFilter={activeFilter} activeCategory={activeCategory} activeStatus={activeStatus} activeClassification={activeClassification} dateRange={dateRange} onAssetSelect={handleAssetSelect} data-id="element-448" />
          </div>
        </div>
        <div className="flex flex-col h-full" data-id="element-449">
          <KPICards activeFilter={activeFilter} activeCategory={activeCategory} activeStatus={activeStatus} activeClassification={activeClassification} dateRange={dateRange} data-id="element-450" />
        </div>
      </div>

      <div className="flex items-center space-x-4 my-2" data-id="element-451">
        <div className="h-px bg-gray-200 flex-1" data-id="element-452"></div>
        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-453">
          Intelligence Insights
        </span>
        <div className="h-px bg-gray-200 flex-1" data-id="element-454"></div>
      </div>

      {/* AI Insights Panel */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-455">
        <AIInsightPanel activeFilter={activeFilter} activeCategory={activeCategory} activeStatus={activeStatus} activeClassification={activeClassification} dateRange={dateRange} data-id="element-456" />
      </div>

      {/* Footer Info */}
      <div className="text-center text-xs text-gray-400 mt-8 pb-4" data-id="element-457">
        <p data-id="element-458">
          Data diperbarui secara real-time. Terakhir sinkronisasi:{' '}
          {new Date().toLocaleTimeString()}
        </p>
      </div>

      {/* Asset Detail Drawer */}
      {isDrawerOpen && <AssetDrawer asset={selectedAsset} isOpen={isDrawerOpen} onClose={handleCloseDrawer} data-id="element-459" />}

      {/* Add Asset Modal */}
      <AddAssetModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onSubmit={handleSubmitAsset} data-id="element-460" />

      {/* Success Notification */}
      <SuccessNotification message={notification.message} isVisible={notification.show} onClose={() => setNotification({
      ...notification,
      show: false
    })} data-id="element-461" />
    </div>;
};